<!-- <div class="d-flex flex-grow-1"> -->
    <!-- Sidebar - Hidden on mobile and tablet, visible on desktop -->
    <!-- <app-sidebar class="d-none d-lg-block bg-white" style="width: 220px; min-height: 0;"></app-sidebar> -->

    <!-- Content - Full width on mobile/tablet, reduced width on desktop -->
    <!-- <div class="flex-grow-1 p-4 main-content">
      <app-alert></app-alert>
      <router-outlet></router-outlet>
    </div>
  </div> -->
 <!-- ─── MAINTENANCE OVERRIDE (GLOBAL) ─── -->
<!-- <ng-container *ngIf="maintenanceData$ | async as maintenance; else normalApp">
  <app-maintenance-page [window]="maintenance"></app-maintenance-page>
</ng-container> -->

<!-- ─── NORMAL APPLICATION ─── -->
<!-- <ng-template #normalApp>

  <div class="d-flex flex-grow-1" *ngIf="!isLandingPage; else fullPage">
    <app-sidebar class="d-none d-lg-block bg-white" style="width: 220px;"></app-sidebar>

    <div class="flex-grow-1 p-4 main-content">
      <app-alert></app-alert>
      <router-outlet></router-outlet>
    </div>
  </div>

  <ng-template #fullPage>
    <router-outlet></router-outlet>
  </ng-template>

</ng-template> -->

<!-- ─── MAINTENANCE OVERRIDE ─── -->
@if (maintenanceData$ | async; as maintenance) {
  <app-maintenance-page [window]="maintenance"></app-maintenance-page>
} @else {

  <!-- ─── NORMAL APPLICATION ─── -->

  <!-- Alert is GLOBAL — works on ALL pages including auth -->
  <app-alert></app-alert>

  <!-- ─── AUTH / LANDING PAGES — no sidebar, no shell ─── -->
  @if (isLandingPage || isAuthPage) {
    <router-outlet></router-outlet>
  } @else {

    <!-- ─── MAIN APP SHELL — sidebar + content ─── -->

    <!-- Mobile Overlay Backdrop -->
    <div
      class="sidebar-backdrop d-lg-none"
      [class.active]="isMobileSidebarOpen"
      (click)="closeSidebar()">
    </div>

    <!-- Sidebar -->
    <aside
      class="app-sidebar bg-white"
      [class.mobile-open]="isMobileSidebarOpen">
      <app-sidebar [isMobileOpen]="isMobileSidebarOpen"></app-sidebar>
    </aside>

    <!-- Main content -->
    <div class="app-content">

      <!-- Mobile header -->
      <header class="mobile-app-header d-lg-none">
        <button
          class="ham-btn"
          (click)="toggleSidebar()"
          [class.open]="isMobileSidebarOpen"
          aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
      </header>

      <main class="main-inner p-3 p-md-4">
        <router-outlet></router-outlet>
      </main>

      <app-footer></app-footer>
    </div>

  }
}